const processData = {
  extractOnlyNumbers(input) {
    if (input === null) {
      return null;
    }

    const numbersOnly = input.toString().match(/\d+/g);
    return numbersOnly ? numbersOnly.join('') : null;
  },
};

export default processData;
